import { render, staticRenderFns } from "./SavedLinksModal.vue?vue&type=template&id=3ed97e14&scoped=true&"
import script from "./SavedLinksModal.vue?vue&type=script&lang=js&"
export * from "./SavedLinksModal.vue?vue&type=script&lang=js&"
import style0 from "./SavedLinksModal.vue?vue&type=style&index=0&id=3ed97e14&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed97e14",
  null
  
)

export default component.exports